export default "__VITE_ASSET__CbCkksvC__"